import { ReservationCalendar } from "@/components/ReservationCalendar";
import { Box, Drawer, Toolbar } from "@mui/material";
import { DrawerProps } from "./DrawerButton";

export default function CalendarDrawer({ open, handleClose }: DrawerProps) {
  return (
    <Drawer
      open={open}
      onClose={handleClose}
      anchor="top"
      PaperProps={{
        sx: {
          height: "100dvh",
          maxHeight: "100dvh",
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      <Toolbar />
      <Box sx={{ flexGrow: 1, minHeight: 0, overflow: "hidden" }}>
        <ReservationCalendar
          onDateClick={handleClose}
          disableReservationSelection
          fullHeight
        />
      </Box>
    </Drawer>
  );
}
